import { Image, type ImageProps } from "@generalapplications/ui";

export type ResponsiveImageProps = {
  /** Any of the image's encoded files; the WebP and PNG beside it are used. */
  src: string;
  alt?: string;
  width: number;
  /** Left out where only the width is known, as for an authored figure. */
  height?: number;
  ratio?: ImageProps["ratio"];
  eager?: boolean;
};

/**
 * An editorial raster image through the library's `Image`: every image under
 * public/images ships as AVIF and WebP with a PNG fallback beside them
 * (scripts/optimize-images.mjs), so a caller names the image, not its files.
 */
export function ResponsiveImage({
  src,
  alt = "",
  width,
  height,
  ratio,
  eager = false,
}: ResponsiveImageProps) {
  const basePath = src.replace(/\.(webp|png|jpg|jpeg|avif)$/i, "");

  return (
    <Image
      avifSrcSet={`${basePath}.avif`}
      webpSrcSet={`${basePath}.webp`}
      fallbackSrc={`${basePath}.png`}
      alt={alt}
      width={width}
      height={height}
      ratio={ratio}
      eager={eager}
    />
  );
}
